import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Loader2, Upload } from "lucide-react";
import { api, downloadFile, errMsg, fmtDate } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { refreshPending } from "./whApi";

function Report({ r }) {
  return (
    <div className="rounded-lg border bg-slate-50 p-3 text-sm space-y-1" data-testid="catalog-import-report">
      <div><b>{r.new}</b> nuovi · <b>{r.updated}</b> aggiornati · <b>{r.missing}</b> spariti (fuori produzione)</div>
      <div><b>{r.printers_new.length}</b> stampanti nuove in attesa{r.printers_new.length > 0 && `: ${r.printers_new.slice(0, 10).join(", ")}${r.printers_new.length > 10 ? "…" : ""}`}</div>
      {r.errors.length > 0 && <div className="text-rose-700 text-xs max-h-28 overflow-y-auto">{r.errors.map((e) => <div key={e}>{e}</div>)}</div>}
    </div>
  );
}

export function CatalogImport({ open, onClose, onDone }) {
  const [file, setFile] = useState(null);
  const [supplier, setSupplier] = useState("");
  const [mark, setMark] = useState(true);
  const [busy, setBusy] = useState(false);
  const [rep, setRep] = useState(null);
  const [log, setLog] = useState([]);
  const [key, setKey] = useState(null);
  useEffect(() => {
    if (!open) return;
    setRep(null);
    api.get("/admin/catalogo/log").then((r) => setLog(r.data)).catch(() => {});
    api.get("/admin/catalogo/api-key").then((r) => setKey(r.data.configured)).catch(() => {});
  }, [open]);
  const go = async () => {
    if (!file || !supplier.trim()) return toast.error("Scegli il file e indica il fornitore");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file); fd.append("supplier", supplier); fd.append("mark_missing", mark);
      const { data } = await api.post("/admin/catalogo/import", fd);
      setRep(data); refreshPending(); onDone?.(); api.get("/admin/catalogo/log").then((r) => setLog(r.data)).catch(() => {});
      toast.success("Listino importato");
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl" data-testid="catalog-import-dialog">
        <DialogHeader><DialogTitle>Import catalogo fornitore</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-600">Colonne: codice, descrizione, barcode, marca, tipo, prezzo_costo, prezzo_consigliato, disponibile, compatibilita (modelli separati da ; o a capo). Aggiorna per codice; i modelli di stampante nuovi finiscono in "Stampanti in attesa".</p>
        <div className="flex flex-wrap gap-2">
          <button data-testid="catalog-template-btn" onClick={() => downloadFile({ url: "/admin/catalogo/template" }, "template-catalogo.csv")} className="press h-9 px-3 rounded border text-xs font-semibold flex items-center gap-1"><Download className="w-3.5 h-3.5" /> Template vuoto</button>
          <button data-testid="catalog-export-btn" onClick={() => downloadFile({ url: "/admin/catalogo/export" }, "catalogo.csv")} className="press h-9 px-3 rounded border text-xs font-semibold flex items-center gap-1"><Download className="w-3.5 h-3.5" /> Esporta catalogo</button>
        </div>
        <input data-testid="catalog-import-file" type="file" accept=".xlsx,.csv" onChange={(e) => setFile(e.target.files?.[0] || null)} className="text-sm" />
        <input data-testid="catalog-import-supplier" value={supplier} onChange={(e) => setSupplier(e.target.value)} placeholder="Fornitore (es. Fornitore A)" className="h-10 px-3 rounded-md border text-sm" />
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={mark} onChange={(e) => setMark(e.target.checked)} data-testid="catalog-import-mark" /> Segna fuori produzione gli articoli di questo fornitore spariti dal file</label>
        <button data-testid="catalog-import-go" onClick={go} disabled={busy} className="press h-11 rounded-md bg-brand-yellow text-brand-navy font-bold flex items-center justify-center gap-2 disabled:opacity-60">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Importa</button>
        {rep && <Report r={rep} />}
        <div className="text-xs text-slate-600 border-t pt-2" data-testid="catalog-api-status">Import automatico dal tuo script: <code>POST /api/admin/catalogo/import</code> con intestazione <code>X-API-Key</code> · chiave {key ? <b className="text-emerald-700">configurata</b> : <b className="text-rose-700">non configurata</b>}</div>
        {log.length > 0 && (
          <div className="text-xs max-h-32 overflow-y-auto border-t pt-2 space-y-0.5" data-testid="catalog-import-log">
            <div className="font-mono uppercase text-slate-500">Registro sincronizzazioni</div>
            {log.map((l) => <div key={l.batch_id}>{fmtDate(l.at)} · {l.supplier} · +{l.new} / {l.updated} agg. / {l.missing} spariti · {l.printers_new.length} stampanti · {l.by}</div>)}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
